import { motion } from "framer-motion";

export const Invitation = () => (
  <section data-testid="hosts-greeting-section" className="relative py-20 sm:py-24 px-6">
    <div className="max-w-2xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-amber-400">
          The Invitation
        </p>
        <div className="gold-divider w-40 mx-auto mt-5" />
        <h2
          data-testid="hosts-parents-names"
          className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-amber-200 mt-8"
        >
          Karan, Avneet &amp; Alagh Family
        </h2>
        <p
          data-testid="hosts-message-body"
          className="text-base leading-relaxed text-zinc-300 mt-6"
        >
          request the honour of your gracious presence at an intimate{" "}
          <span className="text-amber-300">Cocktail Evening</span> at the family residence, as we
          raise a toast to the forthcoming wedding of{" "}
          <span className="font-serif-display text-lg text-amber-100">Sarthak</span> with{" "}
          <span className="font-serif-display text-lg text-amber-100">Tanishka</span>.
        </p>
        <p className="text-sm text-zinc-400 mt-6 italic font-serif-display">
          An evening of spirits, music &amp; celebration — with our closest family, before the big
          day.
        </p>
      </motion.div>
    </div>
  </section>
);
